import axios from 'axios';

import {
  TCREATE_USER, TGET_POLLS_TAKEN, TGET_POLLS_CREATED, TUSER_NOT_CREATED,
  TGET_USERNAME, TGET_USERINFO, TUSER_CREATED, TGET_MATCH_SCORE, TMATCH_SCORE_FAIL,
  TUPDATING_USER, TUSER_UPDATED, TUSER_NOT_UPDATED, TGOT_MATCH_SCORE,
  TFOLLOWING_USER, TUSER_FOLLOWED, TUSER_NOT_FOLLOWED,
  TGETTING_FOLLOWING, TGOT_FOLLOWING, TNOT_GOT_FOLLOWING,
} from './types';
import {
  PCREATE_USER, PGET_POLLS_TAKEN, PGET_POLLS_CREATED, PGET_USERNAME,
  PGET_USERINFO, PEDIT_USER, PGET_MATCH_SCORE, PFOLLOW_USER,
} from './paths';
import {UROOT_API, API_HEADERS} from './api_const';
import {getCurUserJWT} from './firebase_actions';


//// USER API ACTIONS ////
export function createUser(userInfo, callback) {
  const {fullName, username, email, token} = userInfo;
  const headers = Object.assign({}, API_HEADERS);
  headers['X-Auth-User'] = token;

  return (dispatch) => {
    dispatch({type: TCREATE_USER});
    axios.post(UROOT_API+PCREATE_USER, {name: fullName, email, username}, {headers})
      .then( () => {
        dispatch({type: TUSER_CREATED, username});
        dispatch(getFollowing());
        callback();
      })
      .catch(err => {
        console.log("could not create user: ", err);
        dispatch({type: TUSER_NOT_CREATED, errMsg: err});
      });
  };
}

export function getUsernameAndNavTo(usrTkn, hist) {
  const headers = Object.assign({}, API_HEADERS);
  headers['X-Auth-User'] = usrTkn;

  return (dispatch) => {
    axios.get(UROOT_API+PGET_USERNAME, {headers})
      .then(resp => {
        const {username, name} = resp.data;
        dispatch({
          type: TGET_USERNAME,
          username,
          name,
        });
        dispatch(getFollowing());
        hist.replace(`/user/${username}`);
      })
      .catch(error => console.log('could not login/redirect', error));
  };
}

export function getUserInfoFromUName(username, redirCb) {
  const headers = Object.assign({}, API_HEADERS);
  const get_url = `${UROOT_API}${PGET_USERINFO}/${username}`;

  return (dispatch) => {
    axios.get(get_url, {headers})
      .then( resp => dispatch({type: TGET_USERINFO, payload: resp}) )
      .catch(err => {
        if (err.message === 'Request failed with status code 404') {
          redirCb();
        }
        dispatch({type: TUSER_NOT_CREATED, errMsg: err});
      });
  };
}

export const editUserInfo = async (data, callback1, callback2) => {
  const token = await getCurUserJWT();
  const {newData} = data;
  // console.log('edit user action', userInfo);
  const headers = Object.assign({}, API_HEADERS);
  headers['X-Auth-User'] = token;

  return (dispatch) => {
    dispatch({type: TUPDATING_USER});
    axios.post(UROOT_API+PEDIT_USER, newData, {headers})
      .then(resp => {
        dispatch({type: TUSER_UPDATED, updated: resp.data});
        callback1();
        callback2();
      })
      .catch(err => dispatch({type: TUSER_NOT_UPDATED, errMsg: err}));
  };
  // const req = axios.post(
  //   // UROOT_API+PEDIT_USER, {changeTo}, {headers}
  //   // NOTE changing the way pass data, as we dont know the field we are updating
  //   UROOT_API+PEDIT_USER, newData, {headers}
  // );
  //
  // return ({
  //   type: TEDIT_USER,
  //   payload: req,
  // });
};

export const follow = async (uname_to_follow, isFollow) => {
  const token = await getCurUserJWT();
  const data = {uname_to_follow, follow: isFollow};

  const headers = Object.assign({}, API_HEADERS);
  headers['X-Auth-User'] = token;

  return (dispatch) => {
    dispatch({type: TFOLLOWING_USER});
    axios.post(UROOT_API+PFOLLOW_USER, data, {headers})
      .then(resp => {
        dispatch(getFollowing());
        dispatch({type: TUSER_FOLLOWED, confirm_data: resp.data});
      })
      .catch(err => dispatch({type: TUSER_NOT_FOLLOWED, errMsg: err}));
  };
};

export const getFollowing = async () => {
  const token = await getCurUserJWT();
  // console.log('get following??');
  const headers = Object.assign({}, API_HEADERS);
  headers['X-Auth-User'] = token;

  return (dispatch) => {
    dispatch({type: TGETTING_FOLLOWING});
    axios.get(UROOT_API+PFOLLOW_USER, {headers})
      .then(resp => {
        dispatch({type: TGOT_FOLLOWING, confirm_data: resp.data});
      })
      .catch(err => dispatch({type: TNOT_GOT_FOLLOWING, errMsg: err}));
  };
};

export function getMatchScore(uname1, uname2) {
  const headers = Object.assign({}, API_HEADERS);
  const get_url = `${UROOT_API}${PGET_MATCH_SCORE}/${uname1},${uname2}`;
  // const req = axios.get(get_url, {headers});

  return (dispatch) => {
    dispatch({type: TGET_MATCH_SCORE});
    axios.get(get_url, {headers})
      .then(resp => {
        dispatch({type: TGOT_MATCH_SCORE, payload: resp});
      })
      .catch(err => dispatch({type: TMATCH_SCORE_FAIL, errMsg: err}));
  };
}

export function getPollsTakenByUname(uname) {
  const headers = Object.assign({}, API_HEADERS);
  const get_url = `${UROOT_API}${PGET_POLLS_TAKEN}/${uname}`;
  const req = axios.get(get_url, {headers});

  return ({
    type: TGET_POLLS_TAKEN,
    payload: req,
  });
}

export function getPollsCreatedByUname(uname) {
  const headers = Object.assign({}, API_HEADERS);
  const get_url = `${UROOT_API}${PGET_POLLS_CREATED}/${uname}`;
  const req = axios.get(get_url, {headers});

  return ({
    type: TGET_POLLS_CREATED,
    payload: req,
  });
}



// WEBPACK FOOTER //
// ./src/actions/user_api_actions.js